import type { ChangeEvent } from "react";

import { InputPassword } from "@/components/base/input/input-password";
import { Label } from "@/components/base/label";
import { VerticalContainer } from "@/components/layout/vertical-container";
import type { FormInputBaseProps } from "./form-input.model";

interface PasswordInputProps extends FormInputBaseProps {
  externalValidationError?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
}

export const PasswordInput = ({
  externalValidationError,
  id,
  label,
  name,
  onBlur,
  onChange,
  showLabel,
  value,
}: PasswordInputProps) => (
  <VerticalContainer width="full">
    <Label hidden={!showLabel} htmlFor={id ?? "password"} required={true} value={label ?? "Passord"} />
    <InputPassword
      externalValidationError={externalValidationError}
      id={id ?? "password"}
      name={name ?? "Passord"}
      onBlur={onBlur}
      onChange={onChange}
      placeholder={showLabel ? "" : (label ?? "Passord")}
      required={true}
      value={value}
    />
  </VerticalContainer>
);
